module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/zh-hans/6-0e40633d76a403202aef0602969e1d89.jpg";